<app-pt-category-products [category]="category" [title]="title"></app-pt-category-products>
